import { Controller } from "@hotwired/stimulus"

export default class TicketCategoryController extends Controller {
  static targets = ["question", "answer", "answerContainer"]

  declare readonly answerTargets: HTMLElement[]
  declare readonly questionTargets: HTMLElement[]
  declare readonly answerContainerTarget: HTMLElement

  select(event: Event): void {
    const radio = event.currentTarget as HTMLInputElement
    const questionKey = radio.value;

    this.answerTargets.forEach(el => {
      el.classList.toggle("is-completely-hidden", el.dataset.questionAnswerKey !== questionKey)
    });

    this.answerContainerTarget.classList.remove("is-completely-hidden");
  }
}
